import { FrameStencils } from "../types";

export interface GetStencilByIdProps {
  stencils: FrameStencils;
  id: string;
}
export const getStencilById = ({ stencils, id }: GetStencilByIdProps) => {
  const stencil = stencils.find((stencil) => stencil.id === id);
  const index = stencils.findIndex((stencil) => stencil.id === id);

  return { stencil, index };
};
